import { FaMedal, FaClock, FaServer, FaHome } from "react-icons/fa";
import bgImage from '../aboutPage/allAboutImages/zpstock-image-1267.webp'
import groupImage from '../../../assests/devlopment/Group 12.png'
import MISSION from '../../mainSection/aboutPage/allAboutImages/1.jpeg'
import VISION from '../../../assests/2.jpg'
import VALUES from '../../../assests/3.jpg'

const whyPoints = [
  "24/7 support and availability",
  "Flexible and scalable technology solutions",
  "Expert and committed professionals",
  "Unique and tailored staffing services",
  "Client-centric software development",
  "Clear and open communication",
];

const features = [
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
  {
    icon: <FaHome size={34} />,
    title: "Results Driven",
    description:
      "We focus on what comes next. Taking your key idea and crafting an incredible solution and strategy with our expertise is what our clients love the most.",
  },
];

const data = [
  {
    title: "MISSION",
    icon: MISSION,
    description:
      "Help businesses use technology effectively to improve efficiency and growth.",
  },
  {
    title: "VISION",
    icon: VISION,
    description:
      "Become a trusted long-term technology partner for innovation and growth.",
  },
  {
    title: "VALUES",
    icon: VALUES,
    description:
      "Driven by passion and integrity, we commit to delivering meaningful solutions that fulfill every client’s needs with consistency and care.",
  },
];

export default function TakeBusiness() {
  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 py-20 grid grid-cols-1 lg:grid-cols-2 gap-10">

        {/* LEFT IMAGE */}
        <div data-aos="fade-up" className="flex justify-center items-center">
          <img src={groupImage} alt="group" className="max-w-full h-auto" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="space-y-6">

          {/* 🔹 HEADING */}
          <h2 className="text-3xl lg:text-4xl font-semibold text-[#09588D]" data-aos="fade-up">
            Who We Are
          </h2>

          {/* 🔹 INTRO */}
          <p className="text-gray-700 text-base lg:text-lg leading-relaxed" data-aos="fade-right">
            At TekIT Software Solutions, we believe technology should simplify business — not complicate it.
            Since 2018, we’ve helped startups and enterprises turn ideas into scalable, real-world solutions.
            With teams across the USA and India, we combine global expertise with practical execution.
          </p>

          {/* 🔹 WHAT WE DO */}
          <div data-aos="fade-up">
            <h3 className="text-xl font-semibold text-[#09588D] mb-2">What We Do</h3>
            <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm lg:text-base">
              <li>Custom Software Development</li>
              <li>AI & Machine Learning Solutions</li>
              <li>Web & Mobile App Development</li>
              <li>IT Staff Augmentation</li>
              <li>Managed IT Services</li>
            </ul>
          </div>

          {/* 🔹 APPROACH */}
          <div data-aos="fade-up">
            <h3 className="text-xl font-semibold text-[#09588D] mb-2">Our Approach</h3>
            <p className="text-gray-700 text-sm lg:text-base">
              We don’t believe in one-size-fits-all solutions. We understand your goals first, then build scalable,
              practical systems. You’re not just a client — you’re a long-term partner.
            </p>
          </div>

          {/* 🔹 DIFFERENT (CARD STYLE) */}
          <div data-aos="fade-up">
            <h3 className="text-xl font-semibold text-[#09588D] mb-3">What Makes Us Different</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                "We Listen First",
                "We Keep It Practical",
                "We Build for the Long Term",
                "Global Delivery, Personal Approach",
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-gray-100 p-3 rounded-lg text-sm text-gray-800 shadow-sm"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

         

          {/* 🔹 INDUSTRIES */}
          <div data-aos="fade-up">
            <h3 className="text-xl font-semibold text-[#09588D] mb-2">Industries We Work With</h3>
            <div className="flex flex-wrap gap-2">
              {["Healthcare", "Finance", "E-commerce", "Logistics", "Startups"].map((item, i) => (
                <span
                  key={i}
                  className="bg-gray-200 px-3 py-1 rounded-full text-sm text-gray-700"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* 🔹 PROMISE */}
          <div data-aos="fade-up">
            <h3 className="text-xl font-semibold text-[#09588D] mb-2">Our Promise</h3>
            <ul className="space-y-1 text-gray-700 text-sm lg:text-base">
              <li>✔ Honest & transparent communication</li>
              <li>✔ Reliable & on-time delivery</li>
              <li>✔ High-quality scalable solutions</li>
              <li>✔ Continuous support & collaboration</li>
            </ul>
          </div>

          {/* 🔹 CTA */}
          <div className="bg-[#09588D] text-white p-4 rounded-lg mt-4" data-aos="fade-up">
            <h4 className="font-semibold mb-1">Let’s Work Together</h4>
            <p className="text-sm">
              Whether you have an idea, challenge, or ongoing project — we’d love to be part of your journey.
            </p>
          </div>

        </div>
      </div>
<div className="bg-gradient-to-br from-[#09588D] via-[#0b6fb3] to-[#021f36] py-24 px-6 text-white">

  <div className="max-w-7xl mx-auto text-center">

    {/* 🔥 Heading */}
    <h2
      className="text-3xl lg:text-4xl font-bold font-recoleta mb-4"
      data-aos="fade-up"
    >
      Take Your Business to the Next Level 
    </h2>

    <p className="text-white/80 max-w-2xl mx-auto mb-16 text-sm lg:text-base" data-aos="fade-up">
      Empower your business with scalable technology, expert talent, and reliable execution — all under one roof.
    </p>

    {/* 🔥 CREATIVE STAGGERED CARDS */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">

      {data.map((item, index) => (
        <div
          key={index}
          data-aos="fade-up"
          className={`
            relative bg-white/10 backdrop-blur-md border border-white/20 
            rounded-2xl p-6 text-white flex flex-col items-center text-center 
            transition duration-300 hover:scale-105 hover:bg-white/20
            ${index === 1 ? "md:-mt-10 md:mb-10" : ""}
          `}
        >
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-cyan-400/10 to-transparent opacity-0 hover:opacity-100 transition"></div>

          {/* Icon */}
          <img
            src={item.icon}
            alt={item.title}
            className="h-16 w-16 mb-4 z-10"
          />

          {/* Title */}
          <h3 className="font-bold text-lg lg:text-xl mb-2 z-10">
            {item.title}
          </h3>

          {/* Description */}
          <p className="text-white/80 text-sm lg:text-base leading-relaxed z-10">
            {item.description}
          </p>
        </div>
      ))}
    </div>

 

  </div>
</div>


    </div>
  );
}
